export const addComma = (num) => {
	if (num === undefined) return;
	const parts = isNaN(num) ? num : num.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return parts.join(".");
}

export const getServiceType = (type) => {
	switch (type) {
		case '파트너':
			return '/img/units/carousel-tag-partner.png';
		case '스토어':
			return '/img/units/carousel-tag-store.png';
		case '택배배송':
			return '/img/units/carousel-tag-delivery.png';
		case '편픽':
			return '/img/units/carousel-tag-cu.png';
		case '신라면세점':
			return '/img/units/carousel-tag-silla.png';
		default:
			return '';
	}
}

export const getCustomProperty = (clientId) => {
	const apiUrls = JSON.parse(process.env.REACT_APP_API_URLS);
	const apiKey = JSON.parse(process.env.REACT_APP_API_KEYS);


	return {
		clientId: clientId,
		apiUrls: apiUrls[clientId],
		apiKey: apiKey[clientId],
	}
}

export const getKeywordsList = (topKeywords) => {
	let keywordsArr = [];
	let productsObj = {};
	
	topKeywords.map((data) => {
		keywordsArr.push(data.keyword);
		productsObj[data.keyword] = data.top_items
	})
	return {keywordsArr, productsObj}
}

export const replaceAmpersand = (obj) => {
    // 객체의 각 키에 대해 순회
    for (let key in obj) {
        if (typeof obj[key] === 'string') {
            // 값이 문자열인 경우 &를 @@으로 치환
            obj[key] = obj[key].replace('@@', '&');
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            // 값이 객체나 배열인 경우 재귀적으로 함수 호출
            replaceAmpersand(obj[key]);
        }
    }
}

export const redirectToPage = (url, isNewTab = false) => {
    if (isNewTab) {
        window.open(url, "_blank");
		return;
    } 
	// React Native WebView 환경인지 확인
	const isReactNativeWebView = typeof window.ReactNativeWebView !== "undefined";
	if (isReactNativeWebView) {
		window.ReactNativeWebView.postMessage(
			JSON.stringify({ type: 'redirect', url: url })
		);
	} else {
		const targetWindow = window.parent;
		const redirectState = {
			redirectState: true,
			redirectUrl: url,
		}
		targetWindow.postMessage(redirectState, "*");
	}
    
}

export const setColorCode = (colorCode) => {
	if (!colorCode) return;
	const color0 = `rgba(${colorCode[0].red}, ${colorCode[0].green}, ${colorCode[0].blue}, ${colorCode[0].alpha})`;
	const color1 = `rgba(${colorCode[1].red}, ${colorCode[1].green}, ${colorCode[1].blue}, ${colorCode[1].alpha})`;
	const color2 = `rgba(${colorCode[2].red}, ${colorCode[2].green}, ${colorCode[2].blue}, ${colorCode[2].alpha})`;

    document.documentElement.style.setProperty('--color-prim-800', color0);
    document.documentElement.style.setProperty('--color-prim-200', color1);
    document.documentElement.style.setProperty('--color-prim-100', color2);
}

export const validateInput = (type, value) => {
	let exp;
	let res;
	switch (type) {
		case 'email':
			exp = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
			res = new RegExp(exp).test(value);
			return res;
		case 'password':
			exp = /^[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]{8,16}$/;
			res = new RegExp(exp).test(value);
			return res;
		default:
			res = value.length > 0;
			return false;
	}
}

export const groupProductsUsingReduce = (products, sliceIndex) => {
    return products.reduce((accumulator, current, index) => {
        if (index % sliceIndex === 0) {
            accumulator.push([]);
        }
        accumulator[accumulator.length - 1].push(current);
        return accumulator;
    }, []);
}

export const findObjectPosition = (data, targetItemId) => {
    for (let outerIndex = 0; outerIndex < data.length; outerIndex++) {
        const innerArray = data[outerIndex];
        for (let innerIndex = 0; innerIndex < innerArray.length; innerIndex++) {
            if (innerArray[innerIndex].itemId === targetItemId) {
                return [outerIndex, innerIndex];
            }
        }
    }
    return null;
}

export const hasUserMessage = (messages) => {
	return messages.some(message => message.isChatbot === false);
}

export const getVisitState = (currentPage) => {
	if (currentPage === undefined) return;
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || {};
	return visitHistory?.history[currentPage]?.state || false;
}

// export const updateVisitHistory = (currentPage, displayLocation) => {
// 	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || {};
// 	if (visitHistory.history === undefined) {
// 		const initVisitHistory = {
// 			history: {},
// 			prev: {},
// 		}
// 		initVisitHistory.history[currentPage] = {
// 			state: 'visited',
// 			displayLocation: displayLocation,
// 		};
// 		initVisitHistory.prev.pageLocation = currentPage;
// 		initVisitHistory.prev.displayLocation = displayLocation;
// 		sessionStorage.setItem('visitHistory', JSON.stringify(initVisitHistory));
// 	} else {
// 		if (visitHistory.history[currentPage] === undefined) {
// 			visitHistory.history[currentPage] = {
// 				state: 'visited',
// 				displayLocation: displayLocation,
// 			};
// 		} else if (
// 			visitHistory.history[currentPage]?.state === 'visited' && 
// 			visitHistory.prev.displayLocation === 'PRODUCT_DETAIL' &&
// 			visitHistory.prev.pageLocation !== currentPage
// 		) {
// 			visitHistory.history[currentPage] = {
// 				state: 'revisited',
// 				displayLocation: displayLocation,
// 			};
// 		}
// 		visitHistory.prev.pageLocation = currentPage;
// 		visitHistory.prev.displayLocation = displayLocation;
// 		sessionStorage.setItem('visitHistory', JSON.stringify(visitHistory));
// 	}
// }

export const updateVisitHistory = (currentPage, displayLocation) => {
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || { history: {}, prev: {} };
	const { history, prev } = visitHistory;

	let chatType = null;

	// 처음 방문
	if (!history[currentPage]) {
		history[currentPage] = {
			state: 'visited',
			displayLocation: displayLocation,
		};
		if (displayLocation === 'PRODUCT_DETAIL' && prev.pageLocation !== currentPage) {
			chatType = 'default';
		}
	}

	// 재방문 판별
	else if (
		history[currentPage].state === 'visited' &&
		prev.pageLocation !== currentPage &&
		prev.displayLocation === 'PRODUCT_DETAIL'
	) {
		history[currentPage] = {
			state: 'revisited',
			displayLocation: displayLocation,
		};
		if (displayLocation === 'PRODUCT_DETAIL') {
			chatType = 'revisit';
		}
	}

	// prev 갱신
	visitHistory.prev = { pageLocation: currentPage, displayLocation };
	sessionStorage.setItem('visitHistory', JSON.stringify({ history, prev: visitHistory.prev }));

	return chatType; // null | 'default' | 'revisit'
};


export const savePrevPage = (pageLocation, displayLocation) => {
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || { history: {}, prev: {} };
	visitHistory.prev = { pageLocation, displayLocation };
	sessionStorage.setItem('visitHistory', JSON.stringify(visitHistory));
};


export const logToConsole = (data) => {
	const targetWindow = window.parent;
	const chatLog = {
		textResp: data?.text,
		productResp: data?.product,
		itemIdsReq: data?.itemIds,
		exampleResp: data?.examples,
	}
	targetWindow.postMessage({
		type: 'chatLog',
		chatLog: chatLog,
	}, "*");
}

export const sendInputFocusStatus = (state) => {
	const targetWindow = window.parent;
	const inputFocusState = {
		inputFocusState: state,
	}
	targetWindow.postMessage(inputFocusState, "*");
}

export const sendResetState = () => {
	const targetWindow = window.parent;
	const resetState = {
		resetState: true,
	}
	targetWindow.postMessage(resetState, "*");
}

export const sendCloseRequestState = (state) => {
	const targetWindow = window.parent;
	const closeRequestState = {
		closeRequestState: state,
	}
	targetWindow.postMessage(closeRequestState, "*");
}

export const sendMessageExistence = (state) => {
	const targetWindow = window.parent;
	const messageExistence = {
		messageExistence: state,
	}
	targetWindow.postMessage(messageExistence, "*");
}

export const sendUserSentMessageState = (state) => {
	const targetWindow = window.parent;
	const userSentMessageState = {
		userSentMessageState: state,
	}
	targetWindow.postMessage(userSentMessageState, "*");
}

export const sendAddProductToCart = (product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible) => {
    const targetWindow = window.parent;
        
    const prepaidShippingFee = product.prepaidShipping === 'C' ? 'C' : 'P';
    if (!product.variantList || product.variantList.length === 0) {
        console.warn('variantList of product is empty');
		setToastMessage('이 상품은 직접 담아주세요');	// 추후 수정 필요
        setIsToastVisible(true);
        return;
    } else if (product.variantList.length > 1) {
        if (product?.productUrl && product?.productUrl.length > 0) {
            redirectToPage(
                product?.productUrl, 
                isConsole,
                isMobileDevice
            );
        }
        setToastMessage('이 상품은 옵션 선택이 필요해요');
        setIsToastVisible(true);
        return;
    }
    const productInfo = {
        product_no: product.itemId,
        variants_code: product.variantList[0],
        quantity: 1,
        prepaid_shipping_fee: prepaidShippingFee,
    }
    const addProductToCart = {
        addProductToCart: productInfo,
    }
    targetWindow.postMessage(addProductToCart, "*");
}

// Open a centered small popup window
export const openCenteredWindow = (url, name = 'popup', width = 600, height = 700) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;

    const left = Math.max(0, (viewportWidth - width) / 2 + dualScreenLeft);
    const top = Math.max(0, (viewportHeight - height) / 2 + dualScreenTop);

    const features = `scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left},noopener,noreferrer`;
    const newWindow = window.open(url, name, features);
    if (newWindow && newWindow.focus) newWindow.focus();
};